import { render, staticRenderFns } from "./OwalModalPanel.vue?vue&type=template&id=c45a73a4&scoped=true"
import script from "./OwalModalPanel.vue?vue&type=script&lang=js"
export * from "./OwalModalPanel.vue?vue&type=script&lang=js"
import style0 from "./OwalModalPanel.vue?vue&type=style&index=0&id=c45a73a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45a73a4",
  null
  
)

export default component.exports